import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SmsCampaignContent } from './SmsCampaignContent';
import { SMS_CAMPAIGN_FORM_SCHEMA, SmsCampaignFormInput, SmsCampaignFormOutput } from './SmsCampaignValidation';
import { SmsCampaignMode } from './SmsCampaignSteps';

type SmsCampaignProps = {
  mode?: SmsCampaignMode;
  campaignId?: string;
  onExitToList?: () => void;
};

export const SmsCampaign: FC<SmsCampaignProps> = ({ mode = 'create', campaignId, onExitToList }) => {
  const methods = useForm<SmsCampaignFormInput, unknown, SmsCampaignFormOutput>({
    resolver: zodResolver(SMS_CAMPAIGN_FORM_SCHEMA),
    defaultValues: {
      name: '',
      description: '',
      templateId: '',
      templateName: undefined,
      audienceId: '',
      connectorFlowId: '',
      connectorId: '',
      scheduleType: 'sendNow',
      scheduleStart: undefined,
      scheduleEnd: undefined,
    },
    mode: 'onTouched',
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSubmit = (_data: SmsCampaignFormOutput) => {
    // Submit is intentionally controlled by step actions.
  };

  return (
    <FormProvider {...methods}>
      <form className='flex min-h-full flex-col gap-6 p-8' onSubmit={methods.handleSubmit(onSubmit)}>
        <SmsCampaignContent mode={mode} campaignId={campaignId} onExitToList={onExitToList} />
      </form>
    </FormProvider>
  );
};
